let sentryModulePromise;
export const loadSentry = () => {
    sentryModulePromise ??= import('@sentry/react');
    return sentryModulePromise;
};
export const captureException = (...args) => {
    void loadSentry().then((sentry) => sentry.captureException(...args));
};
export const captureMessage = (...args) => {
    void loadSentry().then((sentry) => sentry.captureMessage(...args));
};
export const addBreadcrumb = (...args) => {
    void loadSentry().then((sentry) => sentry.addBreadcrumb(...args));
};
export const withScope = (...args) => {
    void loadSentry().then((sentry) => sentry.withScope(...args));
};
export const setUser = (...args) => {
    void loadSentry().then((sentry) => sentry.setUser(...args));
};
export const setTag = (...args) => {
    void loadSentry().then((sentry) => sentry.setTag(...args));
};
export const setTags = (...args) => {
    void loadSentry().then((sentry) => sentry.setTags(...args));
};
export const setContext = (...args) => {
    void loadSentry().then((sentry) => sentry.setContext(...args));
};
